module.exports = __webpack_public_path__ + "img/m.9a53c8f9.jpg";